import React from 'react';
import PaymentMovementsTable from './table/PaymentMovementsTable';
import { PaymentMovementsUIProvider } from './context/PaymentMovementsUIContext';
import { Box } from '@mui/material';
import PaymentMovementsHeader from './PaymentMovementsHeader';
import LinksDropMenu from '../../paymentLinks/list/LinksDropMenu';

export default function PaymentMovements () {
    // Main Component
    return (
        <PaymentMovementsUIProvider>
            <Box display='flex' flexDirection='column' className='pageContainerFluid'>
                <PaymentMovementsHeader/>
                <div className='menuFlex'>
                    <div className='menuFlexLeft'>
                        <LinksDropMenu />
                    </div>
                    <div className='menuFlexRight'>
                        <PaymentMovementsTable/>
                    </div>
                </div>
            </Box>
        </PaymentMovementsUIProvider>
    );
};
